import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _isArray from "lodash/isArray";
import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";

var _templateObject;

import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.link.js";
import { gql } from '@nerdwallet/apollo';
import { getCategoryObjects, getCanonicalUrl, getDate, getDateModified, getFeaturedImageObject, getTitleSeo } from '@nerdwallet/wp-api/selectors/common';
import { getAuthorSchema, getReviewerSchema, getEditorSchema, getAboutSchema } from './index';
import { getReviewRatingSchema } from '../index';
import { ORGANIZATION } from '../../constants';
/*
 * Get the schema for Article
 *
 * @param  {Object} Article           WordPress Article object
 *
 * @return {Object} Article schema
 */

export var getArticleSchema = function getArticleSchema(article) {
  if (_isEmpty(article)) {
    return null;
  } // eslint-disable-next-line no-use-before-define, no-underscore-dangle


  if (article.__typename) return getArticleSchemaGql(article);
  var authorData = getAuthorSchema(article);
  var reviewerData = getReviewerSchema(article);

  var featuredImages = _get(getFeaturedImageObject(article), ['media_details', 'sizes'], null);

  var imageData = featuredImages && Array.isArray(featuredImages) && featuredImages.slice(0, 3).map(function (featuredImageInfo) {
    return {
      '@type': 'ImageObject',
      url: featuredImageInfo.sourceUrl,
      width: featuredImageInfo.width,
      height: featuredImageInfo.height
    };
  });
  var aboutData = getAboutSchema(getCategoryObjects(article));
  var ArticleClientSchema = {
    '@type': 'Article',
    '@id': "".concat(getCanonicalUrl(article), "#article"),
    // Ensure unique JSON-LD identifier.
    about: aboutData,
    author: authorData,
    dateModified: getDateModified(article),
    datePublished: getDate(article),
    headline: getTitleSeo(article),
    image: imageData,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': getCanonicalUrl(article),
      reviewedBy: reviewerData,
      url: getCanonicalUrl(article)
    },
    publisher: {
      '@id': ORGANIZATION['@id']
    }
  };
  return ArticleClientSchema;
};
getArticleSchema.fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment getArticleSchema on Article {\n    __typename\n    id\n    ...getAuthorSchema\n    ...getReviewerSchema\n    ...getEditorSchema\n    ...getAboutSchema\n\n    featuredMediaForJsonLd: featuredMedia {\n      id\n      mediaDetails {\n        id # Required for ApolloClient 3 to cache properly\n        sizes(\n          sizes: [\n            \"square-350\"\n            \"preview\"\n            \"hero-wide\"\n            \"primary-xl\"\n            \"primary-l\"\n            \"primary-m\"\n          ]\n        ) {\n          size\n          sourceUrl\n          width\n          height\n        }\n      }\n    }\n    link\n    modified\n    date\n    useReviewSchemaType\n    reviewProductName\n    reviewRating\n    contentTags\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"])), getAuthorSchema.fragment, getReviewerSchema.fragment, getEditorSchema.fragment, getAboutSchema.fragment);
/*
 * Get the schema for Article
 *
 * @param  {Object} Article           query0 Article object
 *
 * @return {Object} Article schema
 */

var getArticleSchemaGql = function getArticleSchemaGql(article) {
  var _article$contentTags, _article$featuredMedi, _article$featuredMedi2;

  if (_isEmpty(article)) {
    return null;
  }

  var isNews = (_article$contentTags = article.contentTags) === null || _article$contentTags === void 0 ? void 0 : _article$contentTags.includes('news');
  var authorData = getAuthorSchema(article);
  var reviewerData = getReviewerSchema(article);
  var featuredImages = article === null || article === void 0 ? void 0 : (_article$featuredMedi = article.featuredMediaForJsonLd) === null || _article$featuredMedi === void 0 ? void 0 : (_article$featuredMedi2 = _article$featuredMedi.mediaDetails) === null || _article$featuredMedi2 === void 0 ? void 0 : _article$featuredMedi2.sizes;
  var imageData = _isArray(featuredImages) ? featuredImages.slice(0, 3).map(function (featuredImageInfo) {
    return {
      '@type': 'ImageObject',
      url: featuredImageInfo.sourceUrl,
      width: featuredImageInfo.width,
      height: featuredImageInfo.height
    };
  }) : undefined; // Editor data is only available through GraphQL

  var editorData = getEditorSchema(article);
  var aboutData = getAboutSchema(article);
  var ArticleClientSchema = {
    '@type': isNews ? 'NewsArticle' : 'Article',
    '@id': "".concat(article.link, "#article"),
    // Ensure unique JSON-LD identifier.
    about: aboutData,
    author: authorData,
    editor: editorData,
    dateModified: article === null || article === void 0 ? void 0 : article.modified,
    datePublished: article === null || article === void 0 ? void 0 : article.date,
    headline: article === null || article === void 0 ? void 0 : article.title,
    image: imageData,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': article.link,
      reviewedBy: reviewerData,
      url: article.link
    },
    publisher: {
      '@id': ORGANIZATION['@id']
    },
    isAccessibleForFree: true
  };

  if (article !== null && article !== void 0 && article.useReviewSchemaType && article !== null && article !== void 0 && article.reviewRating && article !== null && article !== void 0 && article.reviewProductName) {
    // These modifications represent the minimum fields we need to end
    // up with a valid Review. It's fine for any extra properties that
    // are specific to Article to also come through above, any extra
    // fields not valid on Review will just be ignored.
    ArticleClientSchema['@type'] = 'Review';
    ArticleClientSchema.reviewRating = getReviewRatingSchema(article === null || article === void 0 ? void 0 : article.reviewRating);
    ArticleClientSchema.itemReviewed = {
      '@type': 'Product',
      name: article === null || article === void 0 ? void 0 : article.reviewProductName
    };
  }

  return ArticleClientSchema;
};